import {
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
    Button,
    Box,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import StorefrontIcon from "@mui/icons-material/Storefront";

const DialogOpzioneDisabilitata = ({ isRitiro, isConsegna, onClose }) => {
    const isOpen = isRitiro || isConsegna;

    let message = "";
    let IconComponent = WarningAmberIcon;

    if (isRitiro) {
        message = "Il gestore ha appena disabilitato il ritiro.";
        IconComponent = StorefrontIcon;
    } else if (isConsegna) {
        message = "Il gestore ha appena disabilitato la consegna.";
        IconComponent = DirectionsCarIcon;
    }

    return (
        <Dialog open={isOpen} disableEscapeKeyDown>
            <DialogContent>
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                    <IconComponent sx={{
                        fontSize: 48,
                        color: isRitiro ? "#4CB9E7" : "#FE7A36",
                        mb: 1
                    }} />
                    <Typography variant="body1" sx={{ mt: 1 }}>
                        {message}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                <Button
                    onClick={onClose}
                    size="small"
                    variant="contained"
                    color="primary"
                    autoFocus
                >
                    Torna indietro
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogOpzioneDisabilitata;